import React, { useState } from "react";
import "./menu.scss";

const menuEs = [
  {
    name: "SUPREMA 7500",
    desc: "Salsa pomodoro, queso mozarella, jamón, tocineta, lomito, cebolla caramelizada, hongos y chile dulce."
  },
  {
    name: "CALZONE BLANCO 6500",
    desc: "Queso mozarella, jamón, hongos, pollo, arugula y tomate cherry."
  },
  {
    name: "LA DE LA CASA 7500",
    desc: "Salsa pomodoro, queso mozarella, tocineta, cebolla caramelizada, chorizo y jalapeños."
  },
  {
    name: "LA LOMITO 7500",
    desc: "Salsa pomodoro, queso mozarella, lomito, cebolla caramelizada y hongos."
  },
  {
    name: "LA PESTO 7500",
    desc: "Pesto, queso mozarella, pollo al grill, tocineta, tomate cherry y cebolla caramelizada."
  },
  {
    name: "LA CHEF 8000",
    desc: "Salsa pomodoro, queso mozarella, tomate cherry, arugula y queso burrata."
  },
  {
    name: "LAS TRADICIONALES 6500",
    desc: "Pizza jamón, Pizza Peperoni, Pizza hawaiana."
  },
  {
    name: "LA DULCE 6000",
    desc: "Nutella, fresas, banano, almendras."
  },
];

const menuEn = [
  {
    name: "SUPREMA 7500",
    desc: "Pomodoro sauce, mozzarella cheese, ham, bacon, beef tenderloin, caramelized onion, mushrooms and sweet chili."
  },
  {
    name: "CALZONE BLANCO 6500",
    desc: "Mozzarella cheese, ham, mushrooms, chicken, arugula and cherry tomato."
  },
  {
    name: "LA DE LA CASA 7500",
    desc: "Pomodoro sauce, mozzarella cheese, bacon, caramelized onion, chorizo and jalapeños."
  },
  {
    name: "LA LOMITO 7500",
    desc: "Pomodoro sauce, mozzarella cheese, beef tenderloin, caramelized onion and mushrooms."
  },
  {
    name: "LA PESTO 7500",
    desc: "Pesto, mozzarella cheese, grilled chicken, bacon, cherry tomato and caramelized onion."
  },
  {
    name: "LA CHEF 8000",
    desc: "Pomodoro sauce, mozzarella cheese, cherry tomato, arugula and burrata cheese."
  },
  {
    name: "LAS TRADICIONALES 6500",
    desc: "Ham pizza, Pepperoni pizza, Hawaiian pizza."
  },
  {
    name: "LA DULCE 6000",
    desc: "Nutella, strawberries, banana, almonds."
  },
];

const MenuSlider = () => {
  const [lang, setLang] = useState("es");
  const menu = lang === "es" ? menuEs : menuEn;

  return (
    <div className="pizzaMenuFeatured" style={{marginBottom: '2rem', background: 'rgba(255,255,255,0.95)', borderRadius: '12px', padding: '2rem', boxShadow: '0 2px 12px rgba(0,0,0,0.08)', border: '2px solid #2ecc40', maxWidth: '700px', marginLeft: 'auto', marginRight: 'auto'}}>
  <h2 style={{textAlign: 'center', fontWeight: 'bold', fontSize: '1rem', marginBottom: '0.5rem', color: '#2ecc40'}}>El Rinconcito de la Pizza</h2>
      <p style={{textAlign: 'center', fontStyle: 'italic', marginBottom: '1.5rem'}}>Ubicado en la Fortuna de San Carlos, Costa Rica</p>
      <h3 style={{textAlign: 'center', fontWeight: 'bold', fontSize: '1.5rem', marginBottom: '1rem'}}>Menú de Pizzas Especiales</h3>
      <div style={{textAlign: 'center', marginBottom: '1.5rem'}}>
  <label style={{marginRight: '1rem', fontWeight: 'bold', color: '#2ecc40', fontSize: '1.5rem', letterSpacing: '1px'}}>Cambiar idioma/ Change Languaje:</label>
        <button onClick={() => setLang(lang === "es" ? "en" : "es")}
          style={{padding: '0.5rem 1.2rem', borderRadius: '1rem', border: '1px solid #2ecc40', background: '#fff', color: '#2ecc40', cursor: 'pointer', fontWeight: 'bold'}}>
          {lang === "es" ? "English" : "Español"}
        </button>
      </div>
      <ul style={{listStyle: 'none', padding: 0, maxWidth: '600px', margin: '0 auto'}}>
        {menu.map((item, idx) => (
          <li key={idx} style={{marginBottom: '1.2rem', background: '#fff7e6', borderRadius: '0.7rem', padding: '1rem 1.2rem', boxShadow: '0 1px 6px rgba(0,0,0,0.04)'}}>
            <strong style={{color: '#2ecc40', fontSize: '1.18rem'}}>{item.name}</strong><br/>
            {item.desc}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MenuSlider;
